<template>
    <div>
        <b-table
            v-if="documentTableItems.length"
            :fields="documentTableFields"
            :items="documentTableItems"
            :key="documentTableKey"
            thead-class="header-class"
            responsive
            striped hover>
            <template #cell(download)="data">
                <GekkoButton 
                    @click="downloadDocument(data.item)"
                    icon="fa-solid fa-download"
                    variant="link" 
                    class="text-info"
                />
            </template>
        </b-table>
        <span v-if="!documentTableItems.length" class="no-doc-found-txt" v-translate>No documents found.</span>
    </div>
</template>

<script>
import GekkoButton from "@/components/GekkoButton";
import DocumentService from "@/store/services/document.service";

export default {
    name: "DocumentList",
    components: {GekkoButton},
    data() {
        return {
            documentTableFields: [
                {key: "type", label: this.$gettext('TYPE')},
                {key: "description", label: this.$gettext('DESCRIPTION')},
                {key: "valid_from", /*sortable: true,*/ label: this.$gettext('VALID FROM')}, // For now, sortable removed
                {key: "valid_until", /*sortable: true,*/ label: this.$gettext('VALID UNTIL')},
                {key: "download", label: ""}
            ],
            documentTableItems: [],
            documentTableKey: 0
        }
    },
    created() {
        let vm = this;

        let params = {"customer": vm.$route.params['contactId']};
        DocumentService.list(params).then(function(response) {
            vm.documentTableItems = response.data.results;
            vm.documentTableKey++;
        });
    },
    methods: {
        downloadDocument(item) {
            DocumentService.getDocumentBlob(item.id).then(response => {
                this.promptDownload(response)
            }).catch(error => console.error('Error downloading Document:', error));
        },
        promptDownload (response) {
            const contentDisposition = response.headers['content-disposition'];
            const filename = this.getDownloadFilename(contentDisposition)
            const url = window.URL.createObjectURL(response.data)
            const a = document.createElement('a')
            a.href = url;
            a.download = filename; // Set the filename
            document.body.appendChild(a)
            a.click(); // Trigger download
            document.body.removeChild(a)
            window.URL.revokeObjectURL(url) // Clean up
        },
        getDownloadFilename (contentDisposition) {
            let filename = 'download'; // Default filename
            if (contentDisposition) {
                console.log(contentDisposition)
                const match = contentDisposition.match(/filename="?([^";]+)"?/);
                if (match && match[1]) {
                filename = match[1]; // Extract the actual filename
                }
            }
            return filename
        },
    }
}
</script>

<style>
/*
.add-document-button {
    padding-bottom: 15px;
}*/

.no-doc-found-txt {
    color: #808080;
}

.header-class {
    font-size: 12px;
}
</style>
